export type SiteInfo = {
  wixEditorAvailable: boolean;
  wixEditorActive: boolean;
  editorUrl?: string;
  siteUrl?: string;
  createSiteUrl?: string;
  published?: boolean;
};

export type GetSiteInfo = () => SiteInfo | null;
